import debounce from "lodash/debounce";
import {
  FirestoreGenerationStatusCode,
  FirestoreProductDescription,
} from "reedy-data/models";
import { logError } from "~/shared/services/error-reporting";
import { PanelFooter } from "~/components/panels";
import { LoadingGenerateDescription } from "./loading-generate-description";
import { Editor } from "~/pages/product-details/tabs/book-description-tab/components/editor";
import { EditorWordCount } from "~/pages/product-details/tabs/book-description-tab/components/editor/editor-word-count";
import { GenerateBookDescriptionError } from "./generate-book-description-error";
import { IKeywords } from "~/pages/product-details/tabs/book-description-tab/components/editor/extensions/keywords";

interface GeneratedDescriptionEditorProps {
  description: FirestoreProductDescription;
  keywords: IKeywords;
  loading: boolean;
  error?: {
    statusCode?: FirestoreGenerationStatusCode | null;
    message?: string | null;
  };
  onUpdate: (hash: string, updatedText: string) => void;
  onRetry: () => void;
  className?: string;
}
export const GeneratedDescriptionEditor = ({
  description,
  keywords,
  loading,
  error,
  onUpdate,
  onRetry,
  className,
}: GeneratedDescriptionEditorProps) => {
  const handleUpdate = debounce((value: string) => {
    if (!description?.hash) {
      logError("Unable to determine description to update. Hash is undefined");
      return;
    }

    return onUpdate(description.hash, value);
  }, 500);

  if (loading) {
    return <LoadingGenerateDescription />;
  }

  if (error) {
    return (
      <GenerateBookDescriptionError
        onClick={() => onRetry()}
        statusCode={error.statusCode}
      />
    );
  }

  return (
    <Editor
      key={description?.hash}
      initialValue={description?.textGenerated}
      keywords={keywords}
      onChange={handleUpdate}
      className={className}
    >
      <PanelFooter justify="end" data-testid="editor-footer">
        <EditorWordCount />
      </PanelFooter>
    </Editor>
  );
};
